<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 0H5V2H9V0ZM1 1H4V2C4 2.55228 4.44772 3 5 3H9C9.55228 3 10 2.55228 10 2V1H13C13.5523 1 14 1.44772 14 2V11.1716C14 11.702 13.7893 12.2107 13.4142 12.5858L11.5858 14.4142C11.2107 14.7893 10.702 15 10.1716 15H1C0.447715 15 0 14.5523 0 14V2C0 1.44772 0.447715 1 1 1ZM3 6.75C3 6.33579 3.33579 6 3.75 6H10.25C10.6642 6 11 6.33579 11 6.75C11 7.16421 10.6642 7.5 10.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM3 10.25C3 9.83579 3.33579 9.5 3.75 9.5H7.25C7.66421 9.5 8 9.83579 8 10.25C8 10.6642 7.66421 11 7.25 11H3.75C3.33579 11 3 10.6642 3 10.25Z"
  />
</template>
